import { Typography } from '@mui/material';

type ReportInfoTemplateProps = {
    title: string;
    value: string;
}

export const ReportInfoTemplate = ({
    title,
    value
}: ReportInfoTemplateProps) => {
    return (
        <>
            <Typography
                variant='subtitle1'
                color='primary.accent'
                component='div'
            >
                {title}:
            </Typography>
            <Typography
                component='div'
                variant='subtitle1'
                gutterBottom
            >
                {value}
            </Typography>
        </>
    );
};
